import en_messages from './en'
import de_messages from './de'
import ru_messages from './ru'
import bs_messages from './bs'
import es_messages from './es'
import fr_messages from './fr'
import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'
import ru from 'react-intl/locale-data/ru'
import bs from 'react-intl/locale-data/bs'
import es from 'react-intl/locale-data/es'
import fr from 'react-intl/locale-data/fr'

const locales = [
    /*{
        locale: 'en',
        messages: en_messages,
        data: en
    },*/
    {
        locale: 'fr',
        messages: fr_messages,
        data: fr
    }

]

export default locales



// WEBPACK FOOTER //
// ./src/locales/index.js